<script>
import TextInput from "@/components/TextInput";
import Message from "@/components/ErrorMessage";
import Captcha from "@/components/Captcha";
import bus from "@/bus";
import { useUserStore } from "../../stores/user";

const statusCodes = {
  201: "views.modals.reset_password.201",
  502: "views.modals.reset_password.502",
};

export default {
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    TextInput,
    Message,
    Captcha,
  },
  data() {
    return {
      email: "",
      message: null,
      valid: true,
    };
  },
  methods: {
    closeModal() {
      bus.emit("closeModal");
    },
    async reset() {
      const { email, valid } = this;

      const error = await this.userStore.resetPasswordRequest({
        email,
        valid,
      });
      if (error) {
        if (error.status) {
          this.message = {
            id: error.headers.date,
            status: error.status,
            message: statusCodes[error.status] || error.data.message,
          };
        }
        return;
      }
      this.message = { status: 201, message: statusCodes[201] };
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <h3 class="mb-2 text-lg text-center text-lightGrey">
      {{ $t("views.modals.reset_password.title") }}
    </h3>
    <br />
    <Message v-if="message" :value="message" @input="message = null" />
    <form @submit.prevent="reset">
      <TextInput id="mail" v-model="email" :label="$t('views.modals.reset_password.email')" type="email" class="mb-4" />
      <Captcha v-model="valid" />
      <div class="w-full flex flex-items-center justify-between">
        <div class="block">
          <a href="#" class="text-sm text-blue-700 hover:text-blue-800" @click="closeModal()">{{
            $t("views.modals.reset_password.return") }}</a>
        </div>
        <button type="submit" class="p-3 bg-airbnbRed text-white text-sm font-semibold rounded ml-auto">
          {{ $t("views.modals.reset_password.send") }}
        </button>
      </div>
    </form>
  </div>
</template>
